import { ref } from 'vue';

/** Map PrimeVue DataTable sortOrder (1 / -1 / 0) to API direction. */
export function mapPrimeSortOrder(sortOrder) {
  if (sortOrder === 1) return 'asc';
  if (sortOrder === -1) return 'desc';
  return null;
}

/** @deprecated Use mapPrimeSortOrder */
export const mapTableSortOrder = mapPrimeSortOrder;

/** True when PrimeVue removableSort cleared the column sort. */
export function isPrimeSortCleared(event) {
  const order = event?.sortOrder;
  return !event?.sortField || order === 0 || order == null;
}

/** PrimeVue :sort-order binding from API direction; omit when inactive. */
export function primeSortOrderFromDirection(direction) {
  if (!direction) return undefined;
  return direction === 'asc' ? 1 : -1;
}

/** PrimeVue :sort-field binding; omit when inactive. */
export function tableSortFieldBinding(field) {
  return field || undefined;
}

/**
 * Client-side DataTable sort that always falls back to a default column.
 * Use for non-lazy tables (settings, departments, analytics).
 */
export function useClientTableSort(defaultField, defaultOrder = 1) {
  const sortField = ref(defaultField);
  const sortOrder = ref(defaultOrder);

  function onSort(event) {
    if (isPrimeSortCleared(event)) {
      sortField.value = defaultField;
      sortOrder.value = defaultOrder;
      return;
    }
    sortField.value = event.sortField;
    sortOrder.value = event.sortOrder;
  }

  return { sortField, sortOrder, onSort };
}
